import React from 'react';
import { Link } from 'react-router-dom';
import Routes from 'routes';
import { Container } from './NotFound.styles';

const NotFound: React.FC = () => {
  return (
    <Container>
      <h1>404 Not Found</h1>
      <p>The page you were looking for could not be found</p>
      <Link to={Routes.Drafts.path}>Return home</Link>
    </Container>
  );
};

export default NotFound;
